import React, { useState, useRef, useEffect, useCallback } from "react";
import axios from 'axios';
import "../../css/dashboard.css";
import { useNavigate, useLocation } from "react-router-dom";
import CommonTable from "../component/table_list/common_table";
import CommonTableRow from "../component/table_list/common_tablerow";
import CommonTableColumn from "../component/table_list/common_tablecolumn";
import Pagination from "react-js-pagination";
import styled from "styled-components";
import DaumPostcode from 'react-daum-postcode';
import { formatDate } from "../utils/format_date";
import { formatWon } from "../utils/format_amount";
import { useAuthContext } from '../common/ProtectedLayout';

const formatPaymentDate = (value) => {
    if (!value) return '-';
    const date = new Date(String(value).replace(' ', 'T'));
    if (Number.isNaN(date.getTime())) return String(value);
    return date.toLocaleString('ko-KR', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
    });
};

const paymentStateLabel = (state) => {
    if (state === 'committed') return '추가결제 완료';
    if (state === 'compensated') return '자동취소 완료';
    return '확인 필요';
};

function ListDetail(props) {
    const location = useLocation();
    const navigate = useNavigate();
    const modalRef = useRef();
    const modalCorrective = useRef();
    const imageModalRef = useRef();
    const completeImageModalRef = useRef(); // 완료 사진 모달 Ref
    const successProcessModalRef = useRef(); // 고객전달사진 모달 Ref
    const addressModalRef = useRef(); // 주소 검색 모달 Ref
    const [addressModalOpen, setAddressModalOpen] = useState(false);
    const productModalRef = useRef(); // 상품 선택 모달 Ref
    const [productList, setProductList] = useState([]);
    const [productModalOpen, setProductModalOpen] = useState(false);

    useEffect(() => {
        if (addressModalOpen) {
            addressModalRef.current?.showModal();
        } else {
            addressModalRef.current?.close();
        }
    }, [addressModalOpen]);

    const [reserve, setReserve] = useState([]);
    const [mglist, setMgList] = useState([]);
    const [page, setPage] = useState(1);
    const items = 10;
    const hadlePageChange = (page) => { setPage(page) };

    const auth = useAuthContext();

    const [initialWorkDate, setInitialWorkDate] = useState('');
    const [initialWorkTime, setInitialWorkTime] = useState('');
    const [imagePath, setImagePath] = useState('');
    const [completeImages, setCompleteImages] = useState([]); // 완료 사진 목록 상태
    const [successProcessImages, setSuccessProcessImages] = useState([]); // 고객전달사진 목록 상태
    const [additionalPaymentInfo, setAdditionalPaymentInfo] = useState({ summary: null, history: [] });
    const [additionalPaymentLoading, setAdditionalPaymentLoading] = useState(false);
    const [additionalPaymentError, setAdditionalPaymentError] = useState(false);

    const getAdditionalPaymentHistory = useCallback(async (reservationIdx) => {
        setAdditionalPaymentLoading(true);
        setAdditionalPaymentError(false);
        try {
            const response = await axios.get(`/Reservation/AdditionalPaymentHistory/${reservationIdx}`);
            setAdditionalPaymentInfo({
                summary: response.data.summary || null,
                history: Array.isArray(response.data.history) ? response.data.history : []
            });
        } catch (error) {
            console.error('Error fetching additional payment history:', error.message);
            setAdditionalPaymentInfo({ summary: null, history: [] });
            setAdditionalPaymentError(true);
        } finally {
            setAdditionalPaymentLoading(false);
        }
    }, []);

    const getReservationDetail = useCallback(async () => {
        try {
            let reserve_result;
            if (location.state.idx) {
                reserve_result = await axios.get(`/Reservation/ReservationId/${location.state.idx}`);
            } else if (location.state.req_number) {
                reserve_result = await axios.get(`/Reservation/ReservationNum/${location.state.req_number}`);
            }

            if (reserve_result && reserve_result.data && reserve_result.data.length > 0) {
                const reservation = reserve_result.data[0];
                setReserve(reservation);
                setInitialWorkDate(reservation.work_date);
                setInitialWorkTime(reservation.work_time);
                await getAdditionalPaymentHistory(reservation.idx);
            }
        } catch (error) {
            console.error('Error fetching reservation count:', error.message);
        }
    }, [getAdditionalPaymentHistory, location.state]);

    const getManagerRegist = async () => {
        try {
            const mg_result = await axios.get('/ManagerRegist');
            setMgList(mg_result.data.message);
        } catch (error) {
            console.error('Error fetching reservation count:', error.message);
        }
    };

    const setReservationMatching = async (managerInfo) => {
        const requestData = {
            managerId: managerInfo.email,
            managerName: managerInfo.name,
            idx: location.state.idx,
            working_step: 1
        };

        try {
            const put_result = await axios.put(`/Reservation`, requestData);
            if (put_result.data.success === true) {
                alert('매니저 매칭이 완료되었습니다');
                getReservationDetail();
                modalRef.current.close();
                const id = auth.loginId;
                const page = "매니저매칭";
                let action = `[ 예약번호 : ${reserve.req_number} ]  [ 담당매니저 : ${managerInfo.email} ]`;
                await axios.post('/ActionLog', { id, page, action });
            } else {
                alert('매니저 매칭에 실패하였습니다');
            }
        } catch (error) {
            console.error('Error updating reservation:', error.message);
        }
    };

    const setReservationCancel = async () => {
        if (!window.confirm("정말 예약을 취소하시겠습니까?")) return;
        try {
            const put_result = await axios.delete(`/Reservation/CancelWithRefund/${location.state.idx}`);
            if (put_result.data.success === true) {
                const refund = put_result.data.refund || {};
                const details = [];
                if (refund.bootpay) details.push('결제 환불');
                if (refund.point) details.push(`포인트 ${refund.pointAmount?.toLocaleString() || 0}P 복원`);
                if (refund.coupon) details.push('쿠폰 복원');
                const detailMsg = details.length > 0 ? `\n(${details.join(', ')})` : '';
                alert(`예약 취소가 완료되었습니다${detailMsg}`);
                navigate('/totalreserve');
                const id = auth.loginId;
                const page = "예약취소";
                let action = `[ 예약번호 : ${reserve.req_number} ]`;
                await axios.post('/ActionLog', { id, page, action });
            } else {
                alert('예약 취소가 실패하였습니다');
            }
        } catch (error) {
            console.error('Error updating reservation:', error.message);
            const serverMsg = error.response?.data?.message;
            alert(serverMsg || '예약 취소 중 오류가 발생했습니다');
        }
    }

    const handleManagerMatching = () => {
        getManagerRegist();
        modalRef.current.showModal();
    }

    const startCorrective = () => {
        modalCorrective.current.showModal();
    }

    const handleCancel = () => {
        setReservationCancel();
    }

    const ChangePhone = (e) => setReserve({ ...reserve, phone: e.target.value });
    const ChangeDate = (e) => setReserve({ ...reserve, work_date: e.target.value });
    const ChangeTime = (e) => setReserve({ ...reserve, work_time: e.target.value });
    const ChangeAddress = (e) => setReserve({ ...reserve, address: e.target.value });
    const handleAddressComplete = (data) => {
        let fullAddress = data.address;
        let extraAddress = '';
        if (data.addressType === 'R') {
            if (data.bname !== '') extraAddress += data.bname;
            if (data.buildingName !== '') {
                extraAddress += (extraAddress !== '' ? `, ${data.buildingName}` : data.buildingName);
            }
            fullAddress += (extraAddress !== '' ? ` (${extraAddress})` : '');
        }
        setReserve(prev => ({ ...prev, address: fullAddress }));
        setAddressModalOpen(false);
    };
    const ChangeAddressSub = (e) => setReserve({ ...reserve, address_sub: e.target.value });
    const ChangeKind = (e) => setReserve({ ...reserve, working_kind: e.target.value });
    const handleProductSelect = (kind) => {
        setReserve(prev => ({ ...prev, working_kind: kind }));
        setProductModalOpen(false);
    };
    const ChangeAmount = (e) => {
        const numOnly = e.target.value.replace(/[^0-9]/g, '');
        setReserve({ ...reserve, amount: numOnly });
    };

    const putCorrective = async () => {
        const requestData = {
            phone: reserve.phone,
            work_date: reserve.work_date,
            work_time: reserve.work_time,
            address: reserve.address,
            address_sub: reserve.address_sub,
            working_kind: reserve.working_kind,
            amount: reserve.amount,
        };
        try {
            const put_result = await axios.put(`/Reservation/${reserve.idx}`, requestData);
            if (put_result.data.success === true) {
                alert('수정이 완료되었습니다');
                modalCorrective.current.close();
                getReservationDetail();

                if (initialWorkDate !== reserve.work_date || initialWorkTime !== reserve.work_time) {
                    let change_date = "";
                    let change_time = "";
                    if (initialWorkDate !== reserve.work_date) change_date = `작업요청일자: ${initialWorkDate} -> ${reserve.work_date}`;
                    if (initialWorkTime !== reserve.work_time) change_time = `작업요청시간: ${initialWorkTime} -> ${reserve.work_time}`;

                    if (change_date || change_time) {
                        const id = auth.loginId;
                        const page = "예약내역수정";
                        let action = change_date ? `[ ${change_date} ]` : "";
                        if (change_time) action = action + ` [  ${change_time} ]`;
                        await axios.post('/ActionLog', { id, page, action });
                        setInitialWorkDate(reserve.work_date);
                        setInitialWorkTime(reserve.work_time);
                    }
                }
            } else {
                alert('수정에 실패하였습니다');
            }
        } catch (error) {
            console.error('Error :', error.message);
        }
    }

    useEffect(() => {
        getReservationDetail();
    }, [getReservationDetail]);

    useEffect(() => {
        const getProductList = async () => {
            try {
                const res = await axios.get('/PriceInfo');
                if (res.data.success) {
                    setProductList(res.data.message);
                }
            } catch (err) {
                console.error("Error fetching product list:", err);
            }
        };
        getProductList();
    }, []);

    useEffect(() => {
        if (productModalOpen) {
            productModalRef.current?.showModal();
        } else {
            productModalRef.current?.close();
        }
    }, [productModalOpen]);

    useEffect(() => {
        if (addressModalOpen) {
            addressModalRef.current?.showModal();
        } else {
            addressModalRef.current?.close();
        }
    }, [addressModalOpen]);

    const startBeforePage = () => {
        if (location.state && location.state.beforePage) {
            navigate(location.state.beforePage);
        } else {
            navigate(-1);
        }
    }

    const showImage = async () => {
        try {
            const response = await axios.get(`/image/user/reservation/${reserve.user_id}/${reserve.req_number}`, {
                responseType: 'blob'
            });
            const imageUrl = URL.createObjectURL(response.data);
            setImagePath(imageUrl);
            imageModalRef.current.showModal();
        } catch (error) {
            console.error('Error fetching image:', error.message);
            alert("첨부된 이미지를 불러올 수 없습니다.");
        }
    };

    const showCompleteImages = async () => {
        try {
            const response = await axios.get(`/imagesName/work_process/${reserve.user_id}/${reserve.req_number}`);
            if (response.data && response.data.images && response.data.images.length > 0) {
                setCompleteImages(response.data.images);
                completeImageModalRef.current.showModal();
            } else {
                alert("등록된 작업 완료 사진이 없습니다.");
            }
        } catch (error) {
            console.error('Error fetching complete images:', error.message);
            alert("작업 완료 사진을 불러올 수 없습니다.");
        }
    };

    const showSuccessProcessImages = async () => {
        try {
            const response = await axios.get(`/imagesName/success_process/${reserve.user_id}/${reserve.req_number}`);
            if (response.data && response.data.images && response.data.images.length > 0) {
                setSuccessProcessImages(response.data.images);
                successProcessModalRef.current.showModal();
            } else {
                alert("등록된 고객전달사진이 없습니다.");
            }
        } catch (error) {
            console.error('Error fetching success process images:', error.message);
            alert("고객전달사진을 불러올 수 없습니다.");
        }
    };

    const paymentSummary = additionalPaymentInfo.summary || {
        initial_amount: reserve.amount,
        additional_payment_count: 0,
        additional_payment_total: 0,
        current_amount: reserve.amount
    };

    return (
        <PageContainer>
            <Card>
                <CardHeader>
                    <Title>예약 상세 정보</Title>
                </CardHeader>

                <EditableGuide>파란 표시 항목은 [수정하기]에서 변경 가능합니다</EditableGuide>

                {/* ✅ [수정] 섹션 병합 및 그리드 배치 최적화 (4열 기준) */}
                <SectionTitle>기본 및 담당자 정보</SectionTitle>
                <GridContainer>
                    <InfoItem label="고객명" value={reserve.user_name} />
                    <InfoItem label="연락처" value={reserve.phone} editable />
                    <InfoItem label="매니저 ID" value={reserve.mg_id || "미배정"} />
                    <InfoItem label="매니저 이름" value={reserve.mg_name || "-"} />
                    <InfoItem label="오더번호" value={reserve.req_number} span={2} /> {/* 2칸 차지 */}
                    <InfoItem label="주소" value={`${reserve.address || ''} ${reserve.address_sub || ''}`} span={2} editable lineClamp={2} />
                </GridContainer>

                <SectionTitle>일정 및 작업 정보</SectionTitle>
                <GridContainer>
                    <InfoItem label="접수일자" value={`${reserve.work_date} ${reserve.work_time}`} editable />
                    <InfoItem label="요청일자" value={`${reserve.req_date} ${reserve.req_time}`} />
                    <InfoItem label="예약상품" value={reserve.working_kind} editable />
                    <InfoItem label="현재 예약금액" value={formatWon(reserve.amount)} isHighlight editable />
                    <InfoItem label="기사금액" value={reserve.mg_amount ? `${reserve.mg_amount.toLocaleString()}원` : '-'} />
                    <InfoItem label="수수료" value={reserve.commission_rate ? `${reserve.commission_rate}%` : '-'} />
                    <InfoItem label="수량" value={reserve.work_count} />
                    <InfoItem label="옵션" value={reserve.option} />

                    {/* 특이사항과 사진 버튼을 한 줄에 배치하여 공간 절약 */}
                    <div style={{ gridColumn: 'span 2', display: 'flex', flexDirection: 'column', gap: '2px' }}>
                        <Label>특이사항</Label>
                        <Value $lineClamp={5}>{reserve.info || '-'}</Value>
                    </div>
                    <div style={{ gridColumn: 'span 2', display: 'flex', alignItems: 'flex-end', gap: '5px' }}>
                        <SecondaryButton onClick={showImage} style={{ width: '100%', padding: '12px 6px', fontSize: '0.9rem' }}>고객첨부사진</SecondaryButton>
                        {/* 작업 완료(working_step === 2)일 때만 완료사진, 고객전달사진 표시 */}
                        {String(reserve.working_step) === '2' && (
                            <>
                                <PrimaryButton onClick={showCompleteImages} style={{ width: '100%', padding: '12px 6px', fontSize: '0.9rem' }}>완료사진</PrimaryButton>
                                <PrimaryButton onClick={showSuccessProcessImages} style={{ width: '100%', padding: '12px 6px', fontSize: '0.9rem', backgroundColor: '#28a745' }}>고객전달사진</PrimaryButton>
                            </>
                        )}
                    </div>
                </GridContainer>

                <SectionTitle>결제 정보</SectionTitle>
                <PaymentSummaryGrid>
                    <PaymentSummaryItem>
                        <PaymentSummaryLabel>최초 예약금액</PaymentSummaryLabel>
                        <PaymentSummaryValue>{formatWon(paymentSummary.initial_amount)}</PaymentSummaryValue>
                    </PaymentSummaryItem>
                    <PaymentSummaryItem>
                        <PaymentSummaryLabel>추가결제 누계</PaymentSummaryLabel>
                        <PaymentSummaryValue $accent>
                            +{formatWon(paymentSummary.additional_payment_total)}
                            <PaymentCount>{Number(paymentSummary.additional_payment_count)}회</PaymentCount>
                        </PaymentSummaryValue>
                    </PaymentSummaryItem>
                    <PaymentSummaryItem>
                        <PaymentSummaryLabel>현재 예약금액</PaymentSummaryLabel>
                        <PaymentSummaryValue $accent>{formatWon(paymentSummary.current_amount)}</PaymentSummaryValue>
                    </PaymentSummaryItem>
                </PaymentSummaryGrid>

                <PaymentHistoryHeader>
                    <PaymentHistoryTitle>결제·금액 이력</PaymentHistoryTitle>
                    {Number(paymentSummary.additional_payment_count) > 0 && (
                        <PaymentHistoryCount>추가결제 {Number(paymentSummary.additional_payment_count)}건</PaymentHistoryCount>
                    )}
                </PaymentHistoryHeader>
                {additionalPaymentLoading ? (
                    <PaymentHistoryMessage>결제 이력을 불러오는 중입니다.</PaymentHistoryMessage>
                ) : additionalPaymentError ? (
                    <PaymentHistoryMessage $error>결제 이력을 불러오지 못했습니다.</PaymentHistoryMessage>
                ) : additionalPaymentInfo.history.length === 0 ? (
                    <PaymentHistoryMessage>추가결제 내역이 없습니다.</PaymentHistoryMessage>
                ) : (
                    <PaymentHistoryList>
                        {additionalPaymentInfo.history.map((item) => (
                            <PaymentHistoryItem key={item.operation_id}>
                                <PaymentHistoryContent>
                                    <PaymentHistoryTopRow>
                                        <PaymentStateBadge $state={item.state}>{paymentStateLabel(item.state)}</PaymentStateBadge>
                                        <PaymentHistoryDate>{formatPaymentDate(item.event_at)}</PaymentHistoryDate>
                                    </PaymentHistoryTopRow>
                                    {item.state === 'committed' && (
                                        <PaymentHistoryMeta>
                                            {formatWon(item.previous_amount)} → {formatWon(item.new_total_amount)}
                                        </PaymentHistoryMeta>
                                    )}
                                    {item.receipt_id_masked && (
                                        <PaymentHistoryMeta>영수증 {item.receipt_id_masked}</PaymentHistoryMeta>
                                    )}
                                </PaymentHistoryContent>
                                <PaymentHistoryAmount $state={item.state}>
                                    {item.state === 'compensated' ? '' : '+'}{formatWon(item.additional_amount)}
                                    {item.state === 'compensated' && <PaymentCancelledText> 결제 취소</PaymentCancelledText>}
                                </PaymentHistoryAmount>
                            </PaymentHistoryItem>
                        ))}
                    </PaymentHistoryList>
                )}

                <ButtonGroup>
                    <div style={{ display: 'flex', gap: '8px' }}>
                        {/* 예약요청(working_step === 0) 상태일 때만 매니저 매칭 버튼 표시 */}
                        {String(reserve.working_step) === '0' && (
                            <PrimaryButton onClick={handleManagerMatching}>매니저 매칭</PrimaryButton>
                        )}
                        <SecondaryButton onClick={startCorrective}>수정하기</SecondaryButton>
                    </div>
                    <div style={{ display: 'flex', gap: '8px' }}>
                        {/* 예약요청(working_step === 0) 상태일 때만 예약취소 버튼 표시 */}
                        {String(reserve.working_step) === '0' && (
                            <DangerButton onClick={handleCancel}>예약취소</DangerButton>
                        )}
                        <OutlineButton onClick={startBeforePage}>목록으로</OutlineButton>
                    </div>
                </ButtonGroup>
            </Card>

            {/* 매니저 매칭 모달 */}
            <StyledDialog ref={modalRef}>
                <DialogHeader>
                    <h3>매니저 매칭</h3>
                    <CloseButton onClick={() => modalRef.current.close()}>&times;</CloseButton>
                </DialogHeader>
                <DialogContent style={{ width: '90vw', maxWidth: '1000px' }}>
                    <CommonTable headerTitle={['No', '아이디', '이름', '전화번호', '가입일자', '선택']}>
                        {mglist.slice(items * (page - 1), items * (page - 1) + items).map((reserve, index) => (
                            <CommonTableRow key={index} idx={reserve.idx} beforePage={'/manager'} kind={'notDetail'}>
                                <CommonTableColumn>{mglist.length - ((page - 1) * 10) - index}</CommonTableColumn>
                                <CommonTableColumn>{reserve.email}</CommonTableColumn>
                                <CommonTableColumn>{reserve.name}</CommonTableColumn>
                                <CommonTableColumn>{reserve.phone_num}</CommonTableColumn>
                                <CommonTableColumn>{formatDate(reserve.regist_date)}</CommonTableColumn>
                                <CommonTableColumn>
                                    <SmallPrimaryButton onClick={() => setReservationMatching(reserve)}>선택</SmallPrimaryButton>
                                </CommonTableColumn>
                            </CommonTableRow>
                        ))}
                    </CommonTable>
                    <PaginationBox>
                        <Pagination
                            activePage={page}
                            itemsCountPerPage={items}
                            totalItemsCount={mglist.length}
                            pageRangeDisplayed={10}
                            onChange={hadlePageChange}
                        />
                    </PaginationBox>
                </DialogContent>
            </StyledDialog>

            {/* 수정 모달 */}
            <StyledDialog ref={modalCorrective}>
                <DialogHeader>
                    <h3>예약 정보 수정</h3>
                    <CloseButton onClick={() => modalCorrective.current.close()}>&times;</CloseButton>
                </DialogHeader>
                <DialogContent style={{ width: '500px' }}>
                    <InputGroup label="접수일자" type="date" value={reserve.work_date} onChange={ChangeDate} />
                    <InputGroup label="접수시간" type="time" value={reserve.work_time} onChange={ChangeTime} />
                    <InputGroup label="연락처" value={reserve.phone} onChange={ChangePhone} />
                    <div style={{ marginBottom: '12px' }}>
                        <Label>주소</Label>
                        <div style={{ display: 'flex', gap: '10px' }}>
                            <StyledInput value={reserve.address || ''} onChange={ChangeAddress} style={{ flex: 1 }} />
                            <OutlineButton onClick={() => setAddressModalOpen(true)} style={{ whiteSpace: 'nowrap' }}>주소 검색</OutlineButton>
                        </div>
                    </div>
                    <InputGroup label="상세주소" value={reserve.address_sub} onChange={ChangeAddressSub} />
                    <div style={{ marginBottom: '12px' }}>
                        <Label>예약상품</Label>
                        <div style={{ display: 'flex', gap: '10px' }}>
                            <StyledInput value={reserve.working_kind || ''} onChange={ChangeKind} style={{ flex: 1 }} readOnly />
                            <OutlineButton onClick={() => setProductModalOpen(true)} style={{ whiteSpace: 'nowrap' }}>변경</OutlineButton>
                        </div>
                    </div>
                    <InputGroup label="예상금액" value={reserve.amount} onChange={ChangeAmount} />

                    <DialogActions>
                        <OutlineButton onClick={() => modalCorrective.current.close()}>취소</OutlineButton>
                        <PrimaryButton onClick={putCorrective}>저장하기</PrimaryButton>
                    </DialogActions>
                </DialogContent>
            </StyledDialog>

            {/* ✅ [수정] 이미지 모달 (확인 버튼 추가) */}
            <StyledDialog ref={imageModalRef}>
                <DialogHeader>
                    <h3>첨부 사진</h3>
                    <CloseButton onClick={() => imageModalRef.current.close()}>&times;</CloseButton>
                </DialogHeader>
                <DialogContent style={{ padding: '20px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <img src={imagePath} alt="첨부사진" style={{ maxWidth: '100%', maxHeight: '60vh', objectFit: 'contain', marginBottom: '20px' }} />
                    <DialogActions>
                        <PrimaryButton onClick={() => imageModalRef.current.close()}>확인</PrimaryButton>
                    </DialogActions>
                </DialogContent>
            </StyledDialog>

            {/* ✅ [추가] 작업 완료 사진 모달 */}
            <StyledDialog ref={completeImageModalRef}>
                <DialogHeader>
                    <h3>작업 완료 사진 ({completeImages.length}장)</h3>
                    <CloseButton onClick={() => completeImageModalRef.current.close()}>&times;</CloseButton>
                </DialogHeader>
                <DialogContent style={{ width: '80vw', maxWidth: '1000px', padding: '20px' }}>
                    <ImageGrid>
                        {completeImages.map((imgName, index) => (
                            <ImageWrapper key={index}>
                                <img
                                    src={`/imagesRead/work_process/${reserve.user_id}/${reserve.req_number}/${imgName}`}
                                    alt={`완료사진 ${index + 1}`}
                                    onClick={() => {
                                        setImagePath(`/imagesRead/work_process/${reserve.user_id}/${reserve.req_number}/${imgName}`);
                                        imageModalRef.current.showModal();
                                    }}
                                />
                            </ImageWrapper>
                        ))}
                    </ImageGrid>
                    <DialogActions>
                        <PrimaryButton onClick={() => completeImageModalRef.current.close()}>확인</PrimaryButton>
                    </DialogActions>
                </DialogContent>
            </StyledDialog>

            {/* ✅ [추가] 고객전달사진 모달 */}
            <StyledDialog ref={successProcessModalRef}>
                <DialogHeader>
                    <h3>고객전달사진 ({successProcessImages.length}장)</h3>
                    <CloseButton onClick={() => successProcessModalRef.current.close()}>&times;</CloseButton>
                </DialogHeader>
                <DialogContent style={{ width: '80vw', maxWidth: '1000px', padding: '20px' }}>
                    <ImageGrid>
                        {successProcessImages.map((imgName, index) => (
                            <ImageWrapper key={index}>
                                <img
                                    src={`/imagesRead/success_process/${reserve.user_id}/${reserve.req_number}/${imgName}`}
                                    alt={`고객전달사진 ${index + 1}`}
                                    onClick={() => {
                                        setImagePath(`/imagesRead/success_process/${reserve.user_id}/${reserve.req_number}/${imgName}`);
                                        imageModalRef.current.showModal();
                                    }}
                                />
                            </ImageWrapper>
                        ))}
                    </ImageGrid>
                    <DialogActions>
                        <PrimaryButton onClick={() => successProcessModalRef.current.close()}>확인</PrimaryButton>
                    </DialogActions>
                </DialogContent>
            </StyledDialog>

            {/* 주소 검색 모달 */}
            <StyledDialog ref={addressModalRef} onClose={() => setAddressModalOpen(false)}>
                <DialogHeader>
                    <h3>주소 검색</h3>
                    <CloseButton onClick={() => setAddressModalOpen(false)}>&times;</CloseButton>
                </DialogHeader>
                <DialogContent>
                    {addressModalOpen && <DaumPostcode onComplete={handleAddressComplete} />}
                </DialogContent>
            </StyledDialog>

            {/* 상품 선택 모달 */}
            <StyledDialog ref={productModalRef} onClose={() => setProductModalOpen(false)}>
                <DialogHeader>
                    <h3>예약상품 선택</h3>
                    <CloseButton onClick={() => setProductModalOpen(false)}>&times;</CloseButton>
                </DialogHeader>
                <DialogContent style={{ width: '400px', maxHeight: '60vh', overflowY: 'auto' }}>
                    {productList.map((product, idx) => (
                        <div
                            key={idx}
                            onClick={() => handleProductSelect(product.kind)}
                            style={{
                                padding: '12px 16px',
                                cursor: 'pointer',
                                borderBottom: '1px solid #f0f0f0',
                                backgroundColor: reserve.working_kind === product.kind ? '#e3f2fd' : 'transparent',
                                transition: 'background-color 0.2s',
                            }}
                            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = reserve.working_kind === product.kind ? '#e3f2fd' : '#f5f5f5'}
                            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = reserve.working_kind === product.kind ? '#e3f2fd' : 'transparent'}
                        >
                            {product.kind}
                        </div>
                    ))}
                </DialogContent>
            </StyledDialog>
        </PageContainer>
    );
}

// --- Image Grid Styles ---
const ImageGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 15px;
    
    @media (max-width: 768px) {
        grid-template-columns: repeat(2, 1fr);
    }
`;

const ImageWrapper = styled.div`
    width: 100%;
    aspect-ratio: 1 / 1;
    border-radius: 8px;
    overflow: hidden;
    border: 1px solid #eee;
    cursor: pointer;
    
    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: transform 0.2s;
        
        &:hover {
            transform: scale(1.05);
        }
    }
`;

// --- Helper Components (span prop 추가) ---
const InfoItem = ({ label, value, span = 1, isHighlight, editable, lineClamp }) => (
    <div style={{
        gridColumn: `span ${span}`, // span 값에 따라 칸 수 차지
        display: 'flex',
        flexDirection: 'column',
        gap: '2px',
        ...(editable && {
            borderLeft: '3px solid #1976d2',
            paddingLeft: '8px',
            backgroundColor: '#f5f9ff',
            borderRadius: '4px',
            padding: '6px 8px',
        })
    }}>
        <Label>{label}</Label>
        <Value $isHighlight={isHighlight} $lineClamp={lineClamp}>{value || '-'}</Value>
    </div>
);

const InputGroup = ({ label, value, onChange, type = "text" }) => (
    <div style={{ marginBottom: '12px' }}>
        <Label>{label}</Label>
        <StyledInput type={type} value={value || ''} onChange={onChange} />
    </div>
);

// --- Styled Components (Compact Version) ---
// --- Styled Components (Balanced Version: 1.5x Spacing) ---

const PageContainer = styled.div`
    padding: 30px 20px; // 상하 30px, 좌우 20px
    background-color: #f5f6f8;
    min-height: 100vh;
    display: flex;
    justify-content: center;
    
    // ✅ [수정] 기존 center(중앙 정렬)에서 flex-start(상단 정렬)로 변경
    align-items: flex-start; 
    
    // ✅ [추가] 상단에 너무 딱 붙지 않도록 약간의 여백 추가 (원하는 만큼 조절 가능)
    padding-top: 50px; 
    
    box-sizing: border-box;
`;

const Card = styled.div`
    background: white;
    width: 100%;
    max-width: 1000px; // 너비도 살짝 늘림
    border-radius: 16px; // 둥글기 증가
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
    padding: 40px 45px; // 내부 여백 1.5배 증가
    display: flex;
    flex-direction: column;
    gap: 25px; // 섹션 간 간격 증가
`;

const CardHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #eee;
    padding-bottom: 15px; // 여백 증가
    margin-bottom: 10px;
`;

const Title = styled.h2`
    font-size: 1.6rem; // 폰트 키움
    color: #111;
    margin: 0;
    font-weight: 800;
`;

const Badge = styled.span`
    padding: 6px 14px; // 뱃지 크기 증가
    border-radius: 20px;
    font-size: 0.9rem;
    font-weight: 600;
    background-color: ${props => props.status === 1 ? '#e3f2fd' : '#fff3e0'};
    color: ${props => props.status === 1 ? '#1976d2' : '#f57c00'};
`;

const EditableGuide = styled.p`
    font-size: 0.8rem;
    color: #1976d2;
    margin: 0;
    padding: 6px 12px;
    background-color: #f5f9ff;
    border-radius: 6px;
    border-left: 3px solid #1976d2;
`;

const SectionTitle = styled.h3`
    font-size: 1.15rem; // 폰트 키움
    color: #333;
    margin: 0 0 12px 0; // 마진 증가
    border-left: 4px solid #006edc; // 두께 증가
    padding-left: 12px;
`;

const GridContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    column-gap: 25px; // 가로 간격 증가
    row-gap: 20px; // 세로 간격 2배 증가 (가독성 확보)
    
    @media (max-width: 768px) {
        grid-template-columns: repeat(2, 1fr);
    }
`;

const PaymentSummaryGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    border: 1px solid #e7e7e7;
    border-radius: 10px;
    overflow: hidden;

    @media (max-width: 768px) {
        grid-template-columns: 1fr;
    }
`;

const PaymentSummaryItem = styled.div`
    padding: 18px 20px;
    background: #fff;
    border-right: 1px solid #e7e7e7;

    &:last-child {
        border-right: none;
    }

    @media (max-width: 768px) {
        border-right: none;
        border-bottom: 1px solid #e7e7e7;

        &:last-child {
            border-bottom: none;
        }
    }
`;

const PaymentSummaryLabel = styled.div`
    color: #777;
    font-size: 0.82rem;
    margin-bottom: 7px;
`;

const PaymentSummaryValue = styled.div`
    color: ${props => props.$accent ? '#006edc' : '#222'};
    font-size: 1.15rem;
    font-weight: 700;
    white-space: nowrap;
`;

const PaymentCount = styled.span`
    margin-left: 8px;
    color: #777;
    font-size: 0.75rem;
    font-weight: 600;
`;

const PaymentHistoryHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 2px;
`;

const PaymentHistoryTitle = styled.h4`
    margin: 0;
    color: #333;
    font-size: 0.95rem;
`;

const PaymentHistoryCount = styled.span`
    color: #006edc;
    background: #eaf3ff;
    border-radius: 10px;
    padding: 3px 8px;
    font-size: 0.72rem;
    font-weight: 700;
`;

const PaymentHistoryList = styled.div`
    border-top: 1px solid #e7e7e7;
`;

const PaymentHistoryItem = styled.div`
    display: flex;
    justify-content: space-between;
    gap: 20px;
    padding: 15px 2px;
    border-bottom: 1px solid #eeeeee;

    &:last-child {
        border-bottom: none;
    }
`;

const PaymentHistoryContent = styled.div`
    min-width: 0;
`;

const PaymentHistoryTopRow = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 6px;
`;

const PaymentStateBadge = styled.span`
    padding: 3px 8px;
    border-radius: 10px;
    font-size: 0.72rem;
    font-weight: 700;
    background: ${props => props.$state === 'committed' ? '#eaf3ff' : props.$state === 'compensated' ? '#f1f1f1' : '#fff3e0'};
    color: ${props => props.$state === 'committed' ? '#006edc' : props.$state === 'compensated' ? '#666' : '#d16a00'};
`;

const PaymentHistoryDate = styled.span`
    color: #777;
    font-size: 0.78rem;
`;

const PaymentHistoryMeta = styled.div`
    color: #777;
    font-size: 0.78rem;
    line-height: 1.55;
`;

const PaymentHistoryAmount = styled.div`
    align-self: center;
    flex-shrink: 0;
    color: ${props => props.$state === 'committed' ? '#006edc' : props.$state === 'compensated' ? '#777' : '#d32f2f'};
    font-size: 0.95rem;
    font-weight: 700;
    white-space: nowrap;
`;

const PaymentCancelledText = styled.span`
    font-size: 0.72rem;
    font-weight: 600;
`;

const PaymentHistoryMessage = styled.div`
    padding: 16px 0;
    border-top: 1px solid #e7e7e7;
    color: ${props => props.$error ? '#d32f2f' : '#888'};
    font-size: 0.85rem;
`;

const Label = styled.div`
    font-size: 0.85rem; // 폰트 복구
    color: #888;
    font-weight: 500;
    margin-bottom: 4px; // 라벨과 값 사이 간격 추가
`;

const Value = styled.div`
    font-size: 1rem; // 본문 폰트 복구
    color: ${props => props.$isHighlight ? '#d32f2f' : '#222'};
    font-weight: ${props => props.$isHighlight ? 'bold' : 'normal'};
    border-bottom: 1px solid #f0f0f0;
    padding-bottom: 6px; // 패딩 증가
    min-height: 24px;
    overflow: hidden;
    ${props => props.$lineClamp ? `
        display: -webkit-box;
        -webkit-line-clamp: ${props.$lineClamp};
        -webkit-box-orient: vertical;
        white-space: normal;
        line-height: 1.4;
        overflow-wrap: anywhere;
    ` : `
        white-space: nowrap;
        text-overflow: ellipsis;
    `}
`;

const ButtonGroup = styled.div`
    display: flex;
    justify-content: space-between;
    margin-top: 25px; // 상단 여백 증가
    padding-top: 25px;
    border-top: 1px solid #eee;
`;

// Button Styles
const BaseButton = styled.button`
    padding: 10px 22px; // 버튼 크기 1.5배 정도 증가
    border-radius: 8px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;
    border: none;
    font-size: 0.95rem; // 폰트 키움
`;

const PrimaryButton = styled(BaseButton)`
    background-color: #006edc;
    color: white;
    &:hover { background-color: #0056b3; }
`;

const SecondaryButton = styled(BaseButton)`
    background-color: #f0f0f0;
    color: #333;
    &:hover { background-color: #e0e0e0; }
`;

const DangerButton = styled(BaseButton)`
    background-color: #fff;
    color: #d32f2f;
    border: 1px solid #d32f2f;
    &:hover { background-color: #fff5f5; }
`;

const OutlineButton = styled(BaseButton)`
    background-color: white;
    border: 1px solid #ccc;
    color: #555;
    &:hover { background-color: #f9f9f9; border-color: #bbb; }
`;

const SmallPrimaryButton = styled(PrimaryButton)`
    padding: 6px 14px;
    font-size: 0.85rem;
`;

// Styled Input
const StyledInput = styled.input`
    width: 100%;
    padding: 10px 12px; // 입력창 여유 있게
    border: 1px solid #ddd;
    border-radius: 6px;
    font-size: 1rem;
    box-sizing: border-box;
    &:focus {
        border-color: #006edc;
        outline: none;
    }
`;

// Dialog Styles
const StyledDialog = styled.dialog`
    border: none;
    border-radius: 16px; // 모달 둥글기 증가
    padding: 0;
    box-shadow: 0 10px 40px rgba(0,0,0,0.25);
    &::backdrop {
        background: rgba(0, 0, 0, 0.6); // 배경 조금 더 어둡게
    }
`;

const DialogHeader = styled.div`
    padding: 20px 25px; // 헤더 여백 증가
    border-bottom: 1px solid #eee;
    display: flex;
    justify-content: space-between;
    align-items: center;
    
    h3 { margin: 0; font-size: 1.3rem; font-weight: 700; }
`;

const DialogContent = styled.div`
    padding: 30px; // 내용 여백 증가
    background: #fff;
    max-height: 80vh;
    overflow-y: auto;
`;

const DialogActions = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    margin-top: 25px;
`;

const CloseButton = styled.button`
    background: none;
    border: none;
    font-size: 1.8rem; // 닫기 버튼 키움
    cursor: pointer;
    color: #999;
    line-height: 1;
    &:hover { color: #333; }
`;

const PaginationBox = styled.div`
  .pagination { display: flex; justify-content: center; margin-top: 20px;}
  ul { list-style: none; padding: 0; display: flex; gap: 6px; }
  ul.pagination li {
    display: inline-block;
    width: 34px; // 페이지네이션 버튼 크기 증가
    height: 34px;
    border: 1px solid #ddd;
    border-radius: 6px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 0.95rem; 
    cursor: pointer;
    background: white;
    transition: all 0.2s;
  }
  ul.pagination li a { text-decoration: none; color: #555; width: 100%; height: 100%; display: flex; align-items: center; justify-content: center; }
  ul.pagination li:hover { background-color: #f5f5f5; }
  ul.pagination li.active { background-color: #006edc; border-color: #006edc; }
  ul.pagination li.active a { color: white; }
`;

export default ListDetail;
